/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getBidline = /* GraphQL */ `
  query GetBidline($bidLineId: String!, $station: String!) {
    getBidline(bidLineId: $bidLineId, station: $station) {
      bidLineId
      station
      bidLocation
      numberOfShifts
      daysOff
      shift {
        shiftType
        shiftDay
        shiftTime {
          startTime
          endTime
          __typename
        }
        __typename
      }
      bidlineHistory {
        user
        notes
        date
        __typename
      }
      __typename
    }
  }
`;
export const getUserProfile = /* GraphQL */ `
  query GetUserProfile {
    getUserProfile {
      employeeId
      firstName
      lastName
      origin
      category
      overrideCategorySeniorDt
      overrideCompanySeniorDt
      categorySeniorDt
      companySeniorDt
      categorySeniorNum
      companySeniorNum
      stationSeniorNum
      station
      payrollShift
      occupation
      area
      probationFlag
      lastUpdated
      jobTitle
      jobProfileId
      integrationSeniority
      overrideFirstName
      overrideLastName
      userApplicationRole
      department
      acesBidLocation
      hours
      daysOff
      contactNumber
      canPerformInspection
      excludeDateExpiration
      overrideAcesBidLocation
      overrideHours
      overrideDaysOff
      overrideContactNumber
      __typename
    }
  }
`;
export const getSeniority = /* GraphQL */ `
  query GetSeniority(
    $serviceType: String!
    $categoryId: String!
    $offset: String!
    $direction: String!
    $deviceType: String!
  ) {
    getSeniority(
      serviceType: $serviceType
      categoryId: $categoryId
      offset: $offset
      direction: $direction
      deviceType: $deviceType
    ) {
      employeeId
      firstName
      lastName
      morrisAirIndicator
      category
      companyHireDate
      categorySeniority
      companySeniority
      station
      payrollShift
      categoryHireDate
      bidLocation
      integrationDate
      bidLineClassification
      __typename
    }
  }
`;
export const searchSeniorityListByField = /* GraphQL */ `
  query SearchSeniorityListByField(
    $categoryId: String!
    $searchField: String
    $searchFieldValue: String
    $stations: String
    $reqLastEvaluatedKey: String
    $deviceType: String!
  ) {
    searchSeniorityListByField(
      categoryId: $categoryId
      searchField: $searchField
      searchFieldValue: $searchFieldValue
      stations: $stations
      reqLastEvaluatedKey: $reqLastEvaluatedKey
      deviceType: $deviceType
    ) {
      records {
        employeeId
        firstName
        lastName
        morrisAirIndicator
        category
        companyHireDate
        categorySeniority
        companySeniority
        station
        payrollShift
        categoryHireDate
        bidLocation
        integrationDate
        bidLineClassification
        __typename
      }
      lastEvaluatedKey
      __typename
    }
  }
`;
export const sortSeniorityListByField = /* GraphQL */ `
  query SortSeniorityListByField(
    $categoryId: String!
    $sortField: String!
    $isAscending: Boolean!
    $stations: String
    $reqLastEvaluatedKey: String
    $deviceType: String!
  ) {
    sortSeniorityListByField(
      categoryId: $categoryId
      sortField: $sortField
      isAscending: $isAscending
      stations: $stations
      reqLastEvaluatedKey: $reqLastEvaluatedKey
      deviceType: $deviceType
    ) {
      records {
        employeeId
        firstName
        lastName
        morrisAirIndicator
        category
        companyHireDate
        categorySeniority
        companySeniority
        station
        payrollShift
        categoryHireDate
        bidLocation
        integrationDate
        bidLineClassification
        __typename
      }
      lastEvaluatedKey
      __typename
    }
  }
`;
export const getMyHours = /* GraphQL */ `
  query GetMyHours($payPeriod: String!) {
    getMyHours(payPeriod: $payPeriod) {
      totalHours
      dateTotals {
        id
        date
        grandTotal
        totals {
          id
          PayCodeName
          AmountInTime
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const getPdfStream = /* GraphQL */ `
  query GetPdfStream($categoryId: String!) {
    getPdfStream(categoryId: $categoryId) {
      pdfStream
      __typename
    }
  }
`;
export const getStations = /* GraphQL */ `
  query GetStations {
    getStations {
      station
      state
      active
      city
      timezone
      __typename
    }
  }
`;
export const getUserProfileById = /* GraphQL */ `
  query GetUserProfileById($employeeId: String!) {
    getUserProfileById(employeeId: $employeeId) {
      employeeId
      firstName
      lastName
      category
      overrideCategorySeniorDt
      overrideCompanySeniorDt
      categorySeniorDt
      companySeniorDt
      overrideFirstName
      overrideLastName
      integrationSeniority
      canPerformInspection
      excludeDateExpiration
      overrideAcesBidLocation
      overrideHours
      overrideDaysOff
      overrideContactNumber
      department
      acesBidLocation
      hours
      daysOff
      contactNumber
      jobProfileId
      jobTitle
      station
      __typename
    }
  }
`;
export const getBidlines = /* GraphQL */ `
  query GetBidlines($station: String!, $workgroup: [String!]!) {
    getBidlines(station: $station, workgroup: $workgroup) {
      bidlineKey
      station
      workgroup
      bidlocation
      shift
      shift_hours
      num_of_lines
      __typename
    }
  }
`;
export const getOTReqMgmtByWorkGStationDate = /* GraphQL */ `
  query GetOTReqMgmtByWorkGStationDate(
    $station: String!
    $workgroup: [String!]!
    $otReqDate: String!
  ) {
    getOTReqMgmtByWorkGStationDate(
      station: $station
      workgroup: $workgroup
      otReqDate: $otReqDate
    ) {
      otReqDate
      otRequestId
      otReqQuantity
      otReqReason
      otReqNotes
      otReqStatus
      fulfillmentStatus
      previousFulfillmentStatus
      action
      station
      shift
      shiftStartEndTime
      bidLocation
      bidLocationGroup
      stationWorkgroupKey
      collectionGrpId
      callOutGrpId
      acceptedBy
      acceptedByEid
      assignedTo
      assignedToId
      completedBy
      createdBy
      createdByEid
      createDtTime
      lastUpdtBy
      lastUpdtByEid
      lastUpdtTime
      timeZone
      __typename
    }
  }
`;
export const getWorkgroups = /* GraphQL */ `
  query GetWorkgroups {
    getWorkgroups {
      workgroupId
      shortname
      workgroup
      __typename
    }
  }
`;
export const getOTReasons = /* GraphQL */ `
  query GetOTReasons {
    getOTReasons {
      otReasons_id
      ot_reason
      __typename
    }
  }
`;
export const getCalloutGroups = /* GraphQL */ `
  query GetCalloutGroups {
    getCalloutGroups {
      station
      grpId
      __typename
    }
  }
`;
export const getEmplOtReqPerUser = /* GraphQL */ `
  query GetEmplOtReqPerUser($empId: String!, $startDate: String!, $endDate: String!) {
    getEmplOtReqPerUser(empId: $empId, startDate: $startDate, endDate: $endDate) {
      otReqDate
      otRequestId
      otReqQuantity
      otReqReason
      otReqNotes
      otReqStatus
      fulfillmentStatus
      previousFulfillmentStatus
      action
      station
      shift
      shiftStartEndTime
      bidLocation
      bidLocationGroup
      stationWorkgroupKey
      collectionGrpId
      callOutGrpId
      acceptedBy
      acceptedByEid
      assignedTo
      assignedToId
      completedBy
      createdBy
      createdByEid
      createDtTime
      lastUpdtBy
      lastUpdtByEid
      lastUpdtTime
      timeZone
      __typename
    }
  }
`;
export const getEmplOtRes = /* GraphQL */ `
  query GetEmplOtRes($otRequestId: String!) {
    getEmplOtRes(otRequestId: $otRequestId) {
      otRequestId
      empId
      otResponseDateTime
      empFirstName
      empLastName
      callResponse
      callOutcome
      comment
      otResponseId
      lastUpdtTime
      __typename
    }
  }
`;
export const callOutEmplyeeLookUp = /* GraphQL */ `
  query CallOutEmplyeeLookUp($empId: String!, $workGroupId: String!, $stationId: String!) {
    callOutEmplyeeLookUp(empId: $empId, workGroupId: $workGroupId, stationId: $stationId) {
      employeeId
      firstName
      lastName
      department
      __typename
    }
  }
`;
export const getOTRequestHistory = /* GraphQL */ `
  query GetOTRequestHistory($otRequestId: String!) {
    getOTRequestHistory(otRequestId: $otRequestId) {
      otRequestId
      otRequestLogId
      bidLocation
      fulfillmentStatus
      lastUpdtBy
      lastUpdtTime
      shift
      shiftStartEndTime
      action
      otReqReason
      otReqQuantity
      otReqNotes
      createdByEid
      lastUpdtByEid
      reviewDate
      reviewTime
      __typename
    }
  }
`;
export const genericQuery = /* GraphQL */ `
  query GenericQuery($event: GenericEventInput!) {
    genericQuery(event: $event) {
      statusCode
      data {
        otReqDate
        otRequestId
        otReqQuantity
        otReqReason
        otReqNotes
        otReqStatus
        fulfillmentStatus
        previousFulfillmentStatus
        action
        station
        shift
        shiftStartEndTime
        bidLocation
        bidLocationGroup
        stationWorkgroupKey
        collectionGrpId
        callOutGrpId
        acceptedBy
        acceptedByEid
        assignedTo
        assignedToId
        completedBy
        createdBy
        createdByEid
        createDtTime
        lastUpdtBy
        lastUpdtByEid
        lastUpdtTime
        timeZone
        __typename
      }
      __typename
    }
  }
`;
export const getEmpOtSignupAndHistory = /* GraphQL */ `
  query GetEmpOtSignupAndHistory($event: GenericEventInput!) {
    getEmpOtSignupAndHistory(event: $event) {
      status
      data {
        empId
        otSignupDate
        emplSignupId
        station
        workgroup
        otBidlocation
        region
        otShift
        otShiftStartEndTime
        createdBy
        createdTime
        stationTimezone
        createdStationTime
        ttl
        action
        __typename
      }
      __typename
    }
  }
`;
export const getEmpOtSignupSummary = /* GraphQL */ `
  query GetEmpOtSignupSummary($event: GenericEventInput!) {
    getEmpOtSignupSummary(event: $event) {
      status
      data {
        empId
        otSignupDate
        station
        workgroup
        region
        isAboveLine
        isBelowLine
        otAwarded
        autoAccept
        contactNumber
        maxShifts
        regularWorkShift
        regularWorkLocation
        normalDaysOff
        createdBy
        createdDtTime
        lastUpdtBy
        lastUpdtTime
        createdStationTime
        stationTimezone
        ttl
        __typename
      }
      __typename
    }
  }
`;
export const getEmpOtRespAndOtReqData = /* GraphQL */ `
  query GetEmpOtRespAndOtReqData($empId: String!, $startDate: String!, $endDate: String!) {
    getEmpOtRespAndOtReqData(empId: $empId, startDate: $startDate, endDate: $endDate) {
      otReqDate
      callOutcome
      callResponse
      comment
      lastUpdtTime
      shift
      shiftStartEndTime
      bidLocation
      station
      bidLocationGroup
      __typename
    }
  }
`;
